import { ITermsOfServiceModalProps } from "./TermsOfServiceModal.types";
import React from "react";
import TermsOfServiceModalView from "./TermsOfServiceModal.view";

const TermsOfServiceModal: React.FC<ITermsOfServiceModalProps> = props => (
  <TermsOfServiceModalView {...props} />
);

export default TermsOfServiceModal;
